module.exports = __webpack_public_path__ + "static/media/boss-bar-yellow-11.35d10735.png";